import  firebase from "firebase";
import "firebase/auth";
//import dataConfig from './dataConfig'

const app = firebase.initializeApp(
    {
      apiKey: "AIzaSyAe1IqIIL2HwggIIpDEO2rvk7Uwteeiu0Y",
      authDomain: "kameliadev-a0de5.firebaseapp.com",
      projectId: "kameliadev-a0de5",
      storageBucket: "kameliadev-a0de5.appspot.com",
      messagingSenderId: "205923669450",
      appId: "1:205923669450:web:adebbfeb6fc0f8efe3ab33",
      measurementId: "G-ZN5WRBJWMJ"
    }
);

/*const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();*/

export default app;